var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8672 0.5C14.4255 0.515592 15.5964 0.925386 15.6016 0.941406C17.4924 1.60682 21.1401 3.61509 22.8252 5.04688L23.3154 5.47656C23.4436 5.59303 23.5873 5.7314 23.6768 5.83887C23.9754 6.17049 24.1249 6.58086 24.125 6.99121C24.125 7.44943 23.9577 7.87617 23.6406 8.22461L23.1377 8.67969L23.0244 8.77637C21.4956 10.1666 17.5033 12.44 15.415 13.1357L15.1006 13.2373C14.7213 13.3513 14.1895 13.4874 13.8672 13.5C13.4571 13.5 13.0648 13.4202 12.6914 13.2627C12.2252 13.042 11.8532 12.6935 11.6475 12.2832C11.5164 11.9992 11.3105 11.1454 11.3105 11.1299C11.122 10.2696 11.0128 8.91199 10.9971 7.39062L10.9951 7.00684C10.9951 5.41269 11.1067 3.95915 11.2744 3.01172L11.4209 2.42285C11.5026 2.11081 11.6106 1.75561 11.7227 1.57422C12.1327 0.910804 12.934 0.500086 13.792 0.5H13.8672ZM7.59473 5.70996C8.43594 5.70996 9.11816 6.28759 9.11816 7C9.11786 7.71338 8.43576 8.28906 7.59473 8.28906L2.81641 8.64355C1.74443 8.64342 0.875305 7.90781 0.875 7C0.875 6.09197 1.74424 5.35561 2.81641 5.35547L7.59473 5.70996Z",
    fill: "#9983FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.fc9c18960ad93dae5cff7a9a3c79504a.svg";
export { ForwardRef as ReactComponent };